import { BiDeltaDirection, kBiVizStyleOptionNames } from '@euler/model/bi/viz';
import { memo } from 'react';
import { BiChip } from '../../../../components/ui/BiChip';
import { StyleGroup } from '../StyleGroup';
import { StyleRow } from '../StyleRow';
import { biPatchedOption, biWithStyleOption } from '../functions/biStyleEdit';
import { BiStyleOptionProps } from '../functions/biStyleOptionProps';

/** Whether the KPI shows its change, and which way is good news. */
export const KpiOptions = memo(({ style, onChange }: BiStyleOptionProps) => {
  const kpi = biPatchedOption(style, 'kpi', {});
  const set = (patch: Partial<typeof kpi>) =>
    onChange(
      biWithStyleOption(style, 'kpi', biPatchedOption(style, 'kpi', patch)),
    );
  return (
    <StyleGroup
      title={kBiVizStyleOptionNames.kpi}
      onReset={
        style?.kpi
          ? () => onChange(biWithStyleOption(style, 'kpi', undefined))
          : null
      }
    >
      <StyleRow label="变化">
        <BiChip
          label="显示"
          selected={kpi.showDelta}
          onPress={() => set({ showDelta: true })}
        />
        <BiChip
          label="隐藏"
          selected={!kpi.showDelta}
          onPress={() => set({ showDelta: false })}
        />
      </StyleRow>
      {kpi.showDelta ? (
        <StyleRow label="好的方向">
          <BiChip
            label="上升为好"
            selected={kpi.deltaGoodWhen === BiDeltaDirection.Up}
            onPress={() => set({ deltaGoodWhen: BiDeltaDirection.Up })}
          />
          <BiChip
            label="下降为好"
            selected={kpi.deltaGoodWhen === BiDeltaDirection.Down}
            onPress={() => set({ deltaGoodWhen: BiDeltaDirection.Down })}
          />
        </StyleRow>
      ) : null}
    </StyleGroup>
  );
});
